import { Component, OnInit, Inject } from '@angular/core';
import { DialogService } from '../../../../services/dialog.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: "kpiadminggform",
    templateUrl: './kpiadmingf-form.component.html',
    styleUrls: ['./kpiadmingf-form.component.less'],
    standalone: false
})
export class KpiAdminGFFormComponent implements OnInit {

    GroupFunctionOptions: { value: string }[] = [];
    SelectedGF: string[] = [];
    MersyId: string = "";
    KpiName: string = "";

    constructor(private confimDialog: DialogService
        , @Inject(MAT_DIALOG_DATA) public data: any
        , public dialogRef: MatDialogRef<KpiAdminGFFormComponent>) {
        this.confimDialog.tthis = this;
    }

    ngOnInit(): void {
        this.GroupFunctionOptions = this.data.GroupFunctions
            .filter((groupFunction: Reference) => !this.data.SelectedGF.includes(groupFunction.Value))
            .map((groupFunction: Reference) => ({ value: groupFunction.Value }));
        this.MersyId = this.data.MersyId;
        this.KpiName = this.data.KpiName;
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onSubmit() {
        this.dialogRef.close(this.SelectedGF);
    }

    onBack() {
    }
}
